module.exports = __webpack_public_path__ + "src/img/loofah/loofah.png?10caf001112f72d49119be1dcc3b3aa2";


//////////////////
// WEBPACK FOOTER
// ./src/img/loofah/loofah.png
// module id = 193
// module chunks = 0